import { render, staticRenderFns } from "./copywritingInfo.vue?vue&type=template&id=5c3f8a4e&scoped=true&"
import script from "./copywritingInfo.vue?vue&type=script&lang=js&"
export * from "./copywritingInfo.vue?vue&type=script&lang=js&"
import style0 from "./copywritingInfo.vue?vue&type=style&index=0&id=5c3f8a4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f8a4e",
  null
  
)

export default component.exports